import React, { Suspense } from 'react';
import MfeErrorFallback from './MfeErrorFallback';
import { useRemoteComponent } from './use-remote-component.hook';
import StaleSharedSingletonBoundary from './StaleSharedSingletonBoundary';
function RemoteComponentLoader({ appData, fallback, loadingIndicator, onInit, onLoaded, componentProps }) {
    const { Component, hasError } = useRemoteComponent({
        appData,
        onInit,
        onLoaded
    });
    const loadingNode = loadingIndicator ? (React.createElement(React.Fragment, null, loadingIndicator)) : (React.createElement("div", null, "Loading..."));
    // Suspense pairs with the React.lazy wrap inside registerAndLoadRemote.
    // The remote's expose is a generated thunk `() => import('./Real')` — the
    // dynamic-import boundary is what makes shared-dep consume sites compile
    // to async loadShare (race-free across concurrent remotes) instead of the
    // eager codegen path. See @honeybook/config-apps for the shim generator.
    if (Component) {
        return (React.createElement(StaleSharedSingletonBoundary, null,
            React.createElement(Suspense, { fallback: loadingNode },
                React.createElement(Component, { ...componentProps }))));
    }
    if (hasError) {
        return fallback ? (React.createElement(React.Fragment, null, fallback)) : (React.createElement(MfeErrorFallback, { appData: appData }));
    }
    return loadingNode;
}
export default RemoteComponentLoader;
//# sourceMappingURL=RemoteComponentLoader.js.map